import { Certification, CertificationUser, UserCertifications } from '../models/Certification.model';
import { StateWithLoading } from '../redux.types';
import {
    addCertificationToUserApi,
    getAllCertificationsApi,
    getAllUserCertificationsApi,
    getCertificationsByUserIdApi
} from 'app/api/certificationsApi';
import { notificationError } from '../actions/Notification/notifications.actions';
import {
    ADD_CERTIFICATION_TO_USER_ALREADY_EXIST,
    ADD_CERTIFICATION_TO_USER_ERROR,
    RETRIEVE_ALL_USER_CERTIFICATIONS_ERROR,
    RETRIEVE_CERTIFICATIONS_BY_USER_ID_ERROR,
    RETRIEVE_CERTIFICATIONS_ERROR
} from 'app/Snackbar/NotificationMessages';
import { createAppSlice, customThunk } from '../redux.helper';

export const certificationsStore = 'certifications';
export const allCertificationsStore = 'allCertifications';
export const userCertificationsStore = 'userCertifications';
export const allUserCertificationsStore = 'allUserCertifications';
export const addedCertificationStore = 'addedCertification';
export const certificationsFilterStore = 'certificationsFilter';

interface CertificationState {
    [allCertificationsStore]: StateWithLoading<Certification[]>;
    [userCertificationsStore]: StateWithLoading<Certification[]>;
    [allUserCertificationsStore]: StateWithLoading<UserCertifications[]>;
    [addedCertificationStore]: StateWithLoading<CertificationUser | null>;
    [certificationsFilterStore]: number[];
}

const initialState: CertificationState = {
    [allCertificationsStore]: {
        data: [],
        loading: false,
        error: null
    },
    [userCertificationsStore]: {
        data: [],
        loading: false,
        error: null
    },
    [allUserCertificationsStore]: {
        data: [],
        loading: false,
        error: null
    },
    [addedCertificationStore]: {
        data: null,
        loading: false,
        error: null
    },
    [certificationsFilterStore]: []
};

const certificationSlice = createAppSlice({
    name: certificationsStore,
    initialState,
    reducers: (create) => ({
        setCertificationsFilter: create.reducer<number[]>((state, { payload }) => {
            state[certificationsFilterStore] = payload;
        }),
        getAllCertifications: customThunk(
            create,
            certificationsStore,
            allCertificationsStore,
            {
                request: getAllCertificationsApi,
                handleNotification: (_error, dispatch) => {
                    dispatch(notificationError(RETRIEVE_CERTIFICATIONS_ERROR));
                },
                cacheData: true
            }
        ),
        getCertificationsByUserId: customThunk(
            create,
            certificationsStore,
            userCertificationsStore,
            {
                request: (id: number) => getCertificationsByUserIdApi(id),
                handleNotification: (_error, dispatch) => {
                    dispatch(notificationError(RETRIEVE_CERTIFICATIONS_BY_USER_ID_ERROR));
                }
            }
        ),
        getAllUserCertifications: customThunk(
            create,
            certificationsStore,
            allUserCertificationsStore,
            {
                request: getAllUserCertificationsApi,
                handleNotification: (_error, dispatch) => {
                    dispatch(notificationError(RETRIEVE_ALL_USER_CERTIFICATIONS_ERROR));
                },
                cacheData: true
            }
        ),
        addCertificationToUser: customThunk(
            create,
            certificationsStore,
            addedCertificationStore,
            {
                request: (certificationUser: CertificationUser) => addCertificationToUserApi(certificationUser),
                handleNotification: (error: any, dispatch) => {
                    if(error?.response?.status === 409) {
                        dispatch(notificationError(ADD_CERTIFICATION_TO_USER_ALREADY_EXIST));
                    } else {
                        dispatch(notificationError(ADD_CERTIFICATION_TO_USER_ERROR));
                    }
                },
                fulfilled: (state, action) => {
                    state[addedCertificationStore].data = action.payload as CertificationUser;
                }
            }
        )
    })
});

export const certificationsReducer = certificationSlice.reducer;

export const certificationActions = certificationSlice.actions;
